module.exports = __webpack_public_path__ + "static/img/other5.9fd3241.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/other5.png
// module id = ln9H
// module chunks = 1